<template>
  <div>
    <div class="items-row">
      <div class="marginer main-content">
        <h1>
          Dashboard
        </h1>
        <div class="yoearth-item" :key="ea._id" v-for="ea in earths">
          <h2>
            {{ ea.title }}
          </h2>
          <p>
            Please copy and paste the code below to the RAW HTML box of edx.
          </p>
          <!-- <textarea class="codebox" v-model="ea.code">
          </textarea> -->
          <textarea class="codebox" :value="generateIFRAME({ earth: ea })"></textarea>
          <a target="_blank" :href="`/view/${me._id}/${ea._id}/${ea.title}`">Go Preview</a>
        </div>
      </div>
      <div class="marginer black-left"></div>
      <div class="marginer ta-left">
        <h1>
          Logout
        </h1>
        <div>
          <button @click="logout()">Logout</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as eAPI from '../yoteach2-gui/SubCompos/eAPI.js'
import * as yoAPI from '../yoteach2-gui/parts/YoNetwork/YoNetwork.js'
export default {
  yoAPI,
  eAPI,
  data () {
    return {
      earths: false,
      me: false,
      codes: []
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    async load () {
      await this.loadMyself()
      await this.loadEarth()
    },
    async loadMyself () {
      this.me = await eAPI.getMyself()
      console.log(this.me)
    },
    async loadEarth () {
      this.earths = await eAPI.getEarth({ userID: this.me._id })
      this.earths = this.earths.map((earth) => {
        return {
          ...earth,
          code: this.buildCode({ earth, me: this.me })
        }
      })
    },
    async logout () {
      await eAPI.logout()
      this.$router.push('/')
    },
    generateIFRAME ({ earth }) {
      let me = this.me
      let ea = earth

      let url = `https://yoearth-builder.netlify.com/view/${encodeURIComponent(me._id)}/${encodeURIComponent(ea._id)}/${encodeURIComponent(ea.title)}`
      let iframe = `<iframe style="border: none; outline: none; width: 100%; height: 700px;" src="${url}" frameborder="0"></iframe>`
      return iframe
    },
    buildCode ({ earth, me }) {
      /* eslint-disable */
      let code = require('raw-loader!./yoearth-code.txt').default
      code = code.replace('<!--earthID-->', earth._id)
      code = code.replace('<!--ownerID-->', me._id)
      code = code.replace('<!--CTA-->', earth.title)
      let r = earth._id
      // let r = '_' + Number(Math.random() * 100000).toFixed(0)
      code = code.replace('<!--r-->', r)
      code = code.replace('<!--r-->', r)
      code = code.replace('<!--r-->', r)
      code = code.replace('<!--r-->', r)
      code = code.replace('<!--r-->', r)
      return code
      /* eslint-enable */
    }
  }
}
</script>

<style scoped>
.marginer{
  margin: 30px;
}
.items-row{
  display: flex;
  flex-wrap: wrap;
}
.black-left{
  border-left: black solid 1px;
}
.main-content{
  width: 600px;
}
.codebox{
  border: grey solid 1px;
  width: 100%;
  overflow: auto;
  height: 350px;
  outline: none;
  font-size: 17px;
}

.yoearth-item{
  border-top: black solid 1px;
  margin-bottom: 20px;
}
</style>
